import $ from 'cash-dom';
import Popup from '../../../components/popup';
import PopupCacheable from '../../../components/PopupCacheable';
import makeStyleableSelects from '../../../widgets/styleable-selects';
import httpRequest from '../../../components/http-request';
import spinner from '../../../components/spinner';
import PpcFilter from './PpcFilter';
import animate from '../../../components/animate';
import FieldsList from './FieldsList';
import FieldsBuilder from './FieldsBuilder';
import Utils from '../../../components/Utils';

let instance = null;

class PpcFilterMobilePopup {
	/**
	 * PpcFilterMobilePopup constructor
	 * @param {{}} initialFilters
	 */
	constructor(initialFilters) {
		if (!instance) {
			this._initted = false;
			this._popup = null;

			this._initialFilters = initialFilters;
			this._setEmptyInitialFilters(initialFilters);
			this._filters = initialFilters;
			this._actionButtonClicked = false;

            const $refineButtonBox = $('.refine-button-box');
            if ($refineButtonBox.length) {
                this._$refineButton = $refineButtonBox.find('button');
                this._$refineButtonBox = $refineButtonBox;
                this._mobilePopupClass = 'mobile-filter-popup-blue';
            } else {
                this._$refineButton = $('.refine-results-button');
                this._$refineButtonBox = this._$refineButton;
                this._mobilePopupClass = 'mobile-filter-popup';
            }

			this._$staticFilterButton = $('.mobile-static-filter-button-container');
			this._showOnStaticDisappear = this._$refineButtonBox.hasClass('show-on-static-disappear');
			this._fieldsList = new FieldsList();

			this._handleReadonly = false;
			this._handleReadonlyInited = false;

			this._$topScrollPositionTrigger = $('.mobile-static-filter-search-container');
			this._ppcLanguage = $('html').attr('lang');

			if ($('.filters').hasClass('hidden')) {
                this._$refineButtonBox.addClass('hidden');
			}

			instance = this;
		}

		return instance;
	}

	_setEmptyInitialFilters(initialFilters) {
		this._emptyInitialFilters = {};

		for (const [name, value] of Object.entries(initialFilters)) {
			if (value && value.val !== 'undefined') {
				this._emptyInitialFilters[name] = {
					val: '',
					vendors: [],
				};
			} else {
				this._emptyInitialFilters[name] = '';
			}
		}
	}

	set initialFilters(value) {
		this._initialFilters = value;
		this._filters = value;
	}

	/**
	 * Gets single instance of the PpcFilterMobilePopup (Singleton).
	 * @param {{}} initialFilters
	 */
	static getInstance(initialFilters) {
		if (!this._instance) {
			this._instance = new this(initialFilters);
		}

		return this._instance;
	}

	init() {
		if (this._initted) {
			return;
		}

		this._initFilterButton();
		this._initted = true;
	}

	_initFilterButton() {
		const self = this;

		const filterButtonClickHandler = function () {
			self._actionButtonClicked = false;
			self._showModal();
            self._$refineButtonBox.hide();
		};

		self._$refineButton.on('click', filterButtonClickHandler);
		self._$staticFilterButton.on('click', filterButtonClickHandler);
	}

	_isPositionToShowTheFirstElement() {
		if (this._$topScrollPositionTrigger.length) {
			return this._$topScrollPositionTrigger.get(0).getBoundingClientRect().bottom < 0;
		}

		const firstElement = this._getFirstElement();

		return (!firstElement || firstElement.getBoundingClientRect().top < 0);
	}

	_getFirstElement() {
		return $('.vendors-list .ppc-single-vendor.ppc-vendor-1').not('.hidden').get(0);
	}

	showFilterButton() {
		if (Utils.getHasVendorsListCarousel()) {
			this._showOnCarouselBottomScroll();
		} else {
			this._showOnFirstVendorScroll();
		}
	}

	_showOnFirstVendorScroll() {
		if (this._$refineButtonBox.hasClass('show-always')) {
			this._showFilterButton();
			return;
		}

		if (this._isPositionToShow()) {
			// we can already be in the position to show.
			// E.g. the page reload and previous needed scroll position was achieved.
			this._showFilterButton();
		}

		window.addEventListener('scroll', () => {
			if (this._isPositionToShow()) {
				this._showFilterButton();
			} else {
				this.hideFilterButton();
			}
		});
	}

	_isPositionToShow() {
		const isMiddleOfScreenAboveTheArticle = this._isMiddleOfScreenAboveTheArticle();

		if (this._showOnStaticDisappear && this._$staticFilterButton.length) {
			return this._$staticFilterButton.get(0).getBoundingClientRect().bottom < 0 && isMiddleOfScreenAboveTheArticle;
		}

		return this._isPositionToShowTheFirstElement() && isMiddleOfScreenAboveTheArticle;
	}

	_isMiddleOfScreenAboveTheArticle() {
		const contentElement = $('.ppc-article').get(0);
		const middleOfScreen = window.innerHeight / 2;

		return !contentElement || (contentElement && contentElement.getBoundingClientRect().top > middleOfScreen);
	}

	_showFilterButton() {
        this._$refineButtonBox.show();
	}

	hideFilterButton() {
        this._$refineButtonBox.hide();
	}

	_showOnCarouselBottomScroll() {
		if (this._$refineButtonBox.hasClass('show-always')) {
			this._showFilterButton();
			return;
		}

		if (this._isPositionToShowForVendorsCarousel()) {
			// we can already be in the position to show.
			// E.g. the page reload and previous needed scroll position was achieved.
			this._showFilterButton();
		}

		window.addEventListener('scroll', () => {
			if (this._isPositionToShowForVendorsCarousel()) {
				this._showFilterButton();
			} else {
				this.hideFilterButton();
			}
		});
	}

	_isPositionToShowForVendorsCarousel() {
		const carousel = Utils.getVendorsCarouselElement().get(0);
		const isCarouselPositionToShow = carousel && carousel.getBoundingClientRect().bottom < (window.innerHeight - 50);

		return isCarouselPositionToShow && this._isMiddleOfScreenAboveTheArticle();
	}

	_hideModal() {
		if (this._popup && typeof this._popup.hide === 'function') {
			this._popup.hide();
		}
	}

	_showModal() {
		const self = this;

		self._filters = PpcFilter.getInstance().getActiveFilters();

		if (self._popup) {
			self._popup.show(null, self._mobilePopupClass);
			PpcFilter.getInstance().setFilters(self._filters);
			this._updateRadioGroupsUI();
			return;
		}

		self._getAndInitModalContent();
	}

	_getAndInitModalContent() {
		const self = this;

		spinner.show();
		httpRequest.post(ajaxurl, {
			action: 'get-ppc-filter-mobile',
			postId: $('body').data('post-id'),
			ppc_language: self._ppcLanguage,
		}, function (error, html) {
			spinner.hide();

			if (error) {
				const popup = new Popup();
				popup.show(tr('Sorry, some error occurred. Please, try again later.'));
			} else {
				self._popup = new PopupCacheable();
				self._popup.show(html, self._mobilePopupClass);
				self._popup.onPopupHide(function () {
					if (!self._showOnStaticDisappear) {
						self._$refineButtonBox.show();
					} else if (self._isPositionToShow()) {
						self._$refineButtonBox.show();
					}

					self._sendAloomaCloseFilterEvent();
				});

				makeStyleableSelects();

				self._fieldsList = FieldsBuilder.build(self._popup.findContent());
				self._fieldsList.setFilters(self._filters);

				PpcFilter.getInstance().setFilters(self._filters);
				self._updateRadioGroupsUI();

				self._attachActionHandlers(self._popup.findContent());
			}
		});
	}

	_sendAloomaCloseFilterEvent() {
		if (!Alooma || this._actionButtonClicked) {
			return;
		}

		this._actionButtonClicked = false;

		$(document).trigger('applyMobileFilters', {filters: this._filters});
	}

	_attachActionHandlers($popupContent) {
		const self = this;

		const $applyButton = $popupContent.find('.apply');
		this._setHandleReadonly($applyButton);

		$applyButton.on('click', function (e) {
			e.preventDefault();

			if (!$applyButton.hasClass('readonly')) {
				self._actionButtonClicked = true;
				const filters = self._fieldsList.getFieldsNameAndValue(false, true);

				if ($applyButton.hasClass('show-loader')) {
					spinner.show();
				}

				self._applyFilters(filters);
				setTimeout(() => {
					spinner.hide();
				}, 200);
			}
		});

		$popupContent.find('.reset').on('click', function (e) {
			e.preventDefault();
			const $reset = $(this);

			self._addReadonlyIfNeeded($applyButton);
			self._actionButtonClicked = true;

			const filtersToSet = $reset.hasClass('to-empty-initial-filters')
				? self._emptyInitialFilters
				: self._initialFilters;

			self._fieldsList.setFilters(filtersToSet);
			const filters = self._fieldsList.getFieldsNameAndValue(false, true);

			self._applyFilters(filters, !$(this).hasClass('dont-close'));

            $('.filters fieldset').each((i, fieldset) => {
                if (fieldset.classList.contains('selected')) {
                    fieldset.classList.remove('selected');
                }
            });
		});

		const $autoCompleteInput = $popupContent.find('.autocomplete-input');

		$autoCompleteInput.on('input', function () {
			self._addOrRemoveReadonlyIfNeeded($(this).val(), $applyButton);
		});

		self._addOrRemoveReadonlyIfNeeded($autoCompleteInput.val(), $applyButton);

		$popupContent.find('.clear-holder').on('click', function () {
			self._addReadonlyIfNeeded($applyButton);
		});
	}

	_addOrRemoveReadonlyIfNeeded(val, $applyButton) {
		if (val) {
			$applyButton.removeClass('readonly');
		} else {
			this._addReadonlyIfNeeded($applyButton);
		}
	}

	_applyFilters(filters, closeAndScroll = true) {
		this._filters = filters;
		$(document).trigger('applyMobileFilters', {filters});

		if (closeAndScroll) {
			this._hideModal();
			this._scrollToTopIfNeed();
		}
	}

	_scrollToTopIfNeed() {
		const firstVendorElement = this._getFirstElement();
		const offset = firstVendorElement ? firstVendorElement.getBoundingClientRect().top + 50 : -1; // -1 means no vendors, so, scroll to top

		if (offset < 0) {
			animate.scrollToTop(firstVendorElement ? firstVendorElement.offsetTop - 20 : 0);
		}
	}

	_setHandleReadonly($applyButton) {
		if (!this._handleReadonlyInited) {
			this._handleReadonly = $applyButton.hasClass('readonly');
			this._handleReadonlyInited = true;
		}
	}

	_addReadonlyIfNeeded($applyButton) {
		if (this._handleReadonly) {
			$applyButton.addClass('readonly');
		}
	}

	_updateRadioGroupsUI() {
		console.log('UPDATE UI');
		const $content = this._popup?.findContent();
		if (!$content) return;

		$content.find('.filter-field[data-type="radio-group"]').each((i, container) => {
			const $container = $(container);
			const filterName = $container.find('input').first().attr('name');
			const currentValue = PpcFilter.getInstance().getActiveFilters()[filterName] || '';

			$container.find('input').prop('checked', false);

			const $target = $container.find(`input[value="${currentValue}"]`);
			if ($target.length) {
				$target.prop('checked', true);
			}
		});
	}
}

export default PpcFilterMobilePopup;
